module.exports = new __parcel__URL__("figma@2x.91aa1139.png").toString();